import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-ag-bubble-chart',
	templateUrl:'./AgBubbleChartPluginCompPage.html',
	styles: [],
	styleUrls:['./AgBubbleChartPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class AgBubbleChartPluginCompPage
{
	mdContent_700 = `\`\`\`java
import com.jwebmp.plugins.agcharts.AgBubbleChart;
\`\`\``;
}
